import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'
import { Input } from '~/components/ui/input'
import { Label } from '~/components/ui/label'

type Props = {
  /** `true` si le modèle a été créé. */
  onCreate: (name: string) => Promise<boolean>
  onCancel: () => void
}

/** Nommer un nouveau modèle d'attestation (#162) ; il part des valeurs par défaut. */
function NewTemplateForm({ onCreate, onCancel }: Props) {
  const { t } = useTranslation()
  const [name, setName] = useState('')
  const [submitting, setSubmitting] = useState(false)

  // Fermé seulement une fois le modèle créé : un échec garde le nom saisi, et
  // un double clic n'en crée pas deux.
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    if (!name.trim() || submitting) return
    setSubmitting(true)
    const created = await onCreate(name.trim())
    setSubmitting(false)
    if (created) onCancel()
  }

  return (
    <form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-2">
      <div className="flex min-w-56 flex-1 flex-col gap-1.5">
        <Label htmlFor="newCertTemplate" required>{t('certificates.templates.newName')}</Label>
        <Input id="newCertTemplate" value={name} onChange={e => setName(e.target.value)} required />
      </div>
      <Button type="button" variant="outline" onClick={onCancel}>{t('common.cancel')}</Button>
      <Button type="submit" disabled={!name.trim() || submitting}>{t('certificates.templates.create')}</Button>
    </form>
  )
}

export default NewTemplateForm
